import axios from 'axios'

export default function () {
  return {
    namespaced: true,
    state: {
      fees: {
        delivery: null
      },
      schedule: {
        deliveryschedule: null
      },
      deliveryCount: 0
    },
    mutations: {
      setSettings (state, settings) {
        settings.forEach(setting => {
          // console.log(setting.propertyType)
          if (setting.propertyType === 'fee:delivery') {
            state.fees.delivery = parseFloat(setting.propertyValue)
          } else if (setting.propertyType === 'DeliverySchedule') {
            state.schedule.deliveryschedule = setting.propertyValue
          }
        })
      },
      setDeliveryFee (state, deliveryFee) {
        state.fees.delivery = deliveryFee
      },
      setSelectedSched (state, scheddate) {
        state.schedule.deliveryschedule = scheddate
      },
      setDeliveryJobsCount (state, count) {
        state.deliveryCount = count
      }
    },
    actions: {
      getFees (context) {
        context.dispatch('auth/getAccessToken', null, {root: true}).then(accessToken => {
          axios.get(`${process.env.API_URL}/admin/settings`, {
            headers: {
              authorization: `Bearer ${accessToken}`
            }
          }).then(result => {
            context.commit('setSettings', result.data)
          })
        })
      },
      updateSettings (context) {
        return context.dispatch('auth/getAccessToken', null, { root: true }).then(accessToken => {
          return axios.post(`${process.env.API_URL}/admin/settings`, {
            settings: [{
              propertyType: 'fee:delivery',
              propertyValue: context.state.fees.delivery + ''
            }]
          }, {
            headers: {
              authorization: `Bearer ${accessToken}`
            }
          }).then(result => {
            context.commit('setSettings', result.data)
          })
        })
      },
      getDeliveryJobsCount (context) {
        return context.dispatch('auth/getAccessToken', null, { root: true }).then(accessToken => {
          return axios.get(`${process.env.API_URL}/admin/delivery-jobs-count?deliveredBy=inomph`, {
            headers: {
              Authorization: `Bearer ${accessToken}`
            }
          }).then(result => {
            context.commit('setDeliveryJobsCount', result.data.count)
          })
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/config.js